const authorize = async (accessToken, serviceIDs, authorizationUrl) => {
  if (!accessToken) {
    throw new Error('invalid accessToken')
  }

  if (!(serviceIDs instanceof Array)) {
    throw new Error('invalid serviceIDs list')
  }

  if (serviceIDs.length === 0) {
    return []
  }

  const url = `${authorizationUrl}${serviceIDs.join(',')}`
  const headers = new Headers()
  headers.append('content-type', 'application/json')
  headers.append('Authorization', 'Bearer ' + accessToken)

  var data = {
    method: 'GET',
    headers: headers,
    credentials: 'include',
    timeout: 5000,
  }

  return await fetch(url, data)
    .then(res => res.json())
    .catch(() => { throw new Error('[GloboID.js] API error') })
}

const authorizeAeid = async (accessToken , type, authorizationAeidUrl) => {
  if (!accessToken) {
    throw new Error('invalid accessToken')
  }

  if (!type || typeof type !== 'string') {
    throw new Error('invalid type')
  }

  const headers = new Headers()
  headers.append('content-type', 'application/json')
  headers.append('Authorization', 'Bearer ' + accessToken)

  var data = {
    method: 'POST',
    headers: headers,
    credentials: 'include',
    body: JSON.stringify({ type: type }),
    timeout: 5000,
  }

  return await fetch(authorizationAeidUrl, data)
    .then(res => res.json())
    .catch(() => { throw new Error('[GloboID.js] API error') })
}

export { authorize, authorizeAeid}